export default "__VITE_ASSET__d3fee2ca__"